import React from 'react';
import * as S from './styled';

const ToggleRangeButton = () => {
  const makeMutation = value => {
    console.log(value);

    if (value === '1') {
      alert('Mutation goedgekeurd');
    } else if (value === '3') {
      alert('Mutation afgekeurd');
    } else {
      alert('Mutation pending');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    style: {
      width: '20px'
    }
  }, /*#__PURE__*/React.createElement(S.ToggleInput, {
    type: "range",
    name: "points",
    onChange: e => makeMutation(e.target.value),
    min: "1",
    max: "3",
    value: "2"
  })));
};

export default ToggleRangeButton;